<template>
  <div class="mobile-hr">
    <!-- 固定Banner图 -->
    <div class="mobile-hr-banner">
      <img 
        :src="require('@/assets/aboutSailHero/img/banner_1.jpg')" 
        alt="人力资源"
        class="mobile-hr-banner__image"
      />
      <div class="mobile-hr-banner__overlay"></div>
      <div class="mobile-hr-banner__content">
        <h1 class="mobile-hr-banner__title">人力资源</h1>
        <p class="mobile-hr-banner__subtitle">HUMAN RESOURCES</p>
      </div>
    </div>

    <!-- Tab切换 -->
    <div class="mobile-hr-tabs">
      <button 
        :class="['mobile-hr-tab', { 'mobile-hr-tab--active': activeTab === 'policy' }]"
        @click="activeTab = 'policy'"
      >
        人才政策
      </button>
      <button 
        :class="['mobile-hr-tab', { 'mobile-hr-tab--active': activeTab === 'jobs' }]"
        @click="activeTab = 'jobs'"
      >
        招聘信息
      </button>
    </div>

    <!-- 人才政策内容 -->
    <div class="mobile-hr-container" v-show="activeTab === 'policy'">
      <div class="mobile-hr-policy">
        <!-- 人才政策简介 -->
        <div class="mobile-hr-policy-intro">
          <img 
            :src="require('@/assets/humanResources/img/ds_5.jpg')" 
            alt="人才政策"
            class="mobile-hr-policy-intro__image"
          />
          <h3 class="mobile-hr-policy-intro__title">人才政策</h3>
          <p class="mobile-hr-policy-intro__text">
            人才是先河环保的第一资源。先河环保始终把人才作为企业发展的创业之本、竞争之本、发展之本。经过二十多年地不断发展已经形成了公开、公正、公平、尊重知识和人才的良好企业风气。公司以其独特的人才招聘战略、开阔的事业发展空间、优良的人才成长环境、有效的激励机制和人本的企业文化理念，是企业成为人才集聚的高地。
          </p>
          <p class="mobile-hr-policy-intro__principle">
            用人原则：德才兼备，以德为先；用人之道：用人之愿、用人之潜、用人之长。
          </p>
        </div>

        <!-- 薪酬福利 -->
        <div class="mobile-hr-salary">
          <h3 class="mobile-hr-salary__title">薪酬福利</h3>
          
          <!-- 四大福利图片卡片 -->
          <div class="mobile-hr-salary__cards">
            <div class="mobile-hr-salary__card">
              <img :src="require('@/assets/humanResources/img/t_1.jpg')" alt="基本薪资" class="mobile-hr-salary__card-img">
            </div>
            <div class="mobile-hr-salary__card">
              <img :src="require('@/assets/humanResources/img/t_2.jpg')" alt="绩效奖金" class="mobile-hr-salary__card-img">
            </div>
            <div class="mobile-hr-salary__card">
              <img :src="require('@/assets/humanResources/img/t_3.jpg')" alt="全面福利" class="mobile-hr-salary__card-img">
            </div>
            <div class="mobile-hr-salary__card">
              <img :src="require('@/assets/humanResources/img/t_4.jpg')" alt="补充津贴" class="mobile-hr-salary__card-img">
            </div>
          </div>

          <!-- 福利项目列表 -->
          <div class="mobile-hr-salary__items">
            <div class="mobile-hr-salary__item">行业具有竞争力的薪酬水平</div>
            <div class="mobile-hr-salary__item">五险一金</div>
            <div class="mobile-hr-salary__item">每年职评调薪机会</div>
            <div class="mobile-hr-salary__item">免费通勤</div>
            <div class="mobile-hr-salary__item">日常奖励</div>
            <div class="mobile-hr-salary__item">节假日福利</div>
            <div class="mobile-hr-salary__item">年度绩效奖励</div>
            <div class="mobile-hr-salary__item">成本价午餐</div>
            <div class="mobile-hr-salary__item">专项奖励</div>
            <div class="mobile-hr-salary__item">年度评优奖励</div>
            <div class="mobile-hr-salary__item">营销专项奖励</div>
            <div class="mobile-hr-salary__item">文体娱乐活动</div>
            <div class="mobile-hr-salary__item">技术专项奖励</div>
            <div class="mobile-hr-salary__item">通讯补贴</div>
            <div class="mobile-hr-salary__item">成本节约奖励</div>
            <div class="mobile-hr-salary__item">出差补贴</div>
            <div class="mobile-hr-salary__item">利润贡献奖励</div>
            <div class="mobile-hr-salary__item">年度业绩奖金</div>
          </div>
        </div>

        <!-- 福利体系 -->
        <div class="mobile-hr-image-section">
          <h3 class="mobile-hr-image-section__title">福利体系</h3>
          <img :src="require('@/assets/humanResources/img/t_5.png')" alt="福利体系" class="mobile-hr-image-section__img">
        </div>

        <!-- 职场通道 -->
        <div class="mobile-hr-image-section">
          <h3 class="mobile-hr-image-section__title">职场通道</h3>
          <img :src="require('@/assets/humanResources/img/t_7.png')" alt="职场通道" class="mobile-hr-image-section__img">
        </div>

        <!-- 培养体系 -->
        <div class="mobile-hr-image-section">
          <h3 class="mobile-hr-image-section__title">培养体系</h3>
          <img :src="require('@/assets/humanResources/img/t_8.png')" alt="培养体系" class="mobile-hr-image-section__img">
        </div>

        <!-- 应届生培训 -->
        <div class="mobile-hr-image-section">
          <h3 class="mobile-hr-image-section__title">应届生培训</h3>
          <img :src="require('@/assets/humanResources/img/t_9.png')" alt="应届生培训" class="mobile-hr-image-section__img">
        </div>
      </div>
    </div>

    <!-- 招聘信息内容 -->
    <div class="mobile-hr-container" v-show="activeTab === 'jobs'">
      <div class="mobile-hr-jobs">
        <!-- 加载状态 -->
        <div class="mobile-hr-loading" v-if="loading && jobList.length === 0">
          <div class="mobile-hr-loading__spinner"></div>
          <p class="mobile-hr-loading__text">加载中...</p>
        </div>

        <!-- 职位列表 -->
        <div v-else-if="displayList && displayList.length > 0">
          <div 
            v-for="(item, index) in displayList"
            :key="item.id || index"
            class="mobile-hr-job-card"
          >
            <h3 class="mobile-hr-job-card__title">{{ item.job_name }}</h3>
            
            <div class="mobile-hr-job-card__meta">
              <div class="mobile-hr-job-card__meta-item">
                <img :src="require('@/assets/humanResources/img/icon_dz.png')" class="mobile-hr-job-card__meta-icon">
                {{ item.work_location }}
              </div>
              <div class="mobile-hr-job-card__meta-item">
                <img :src="require('@/assets/humanResources/img/icon_xl.png')" class="mobile-hr-job-card__meta-icon">
                {{ item.education }}
              </div>
              <div class="mobile-hr-job-card__meta-item">
                <img :src="require('@/assets/humanResources/img/icon_rs.png')" class="mobile-hr-job-card__meta-icon">
                {{ item.department }}
              </div>
            </div>

            <div class="mobile-hr-job-card__section" v-if="item.major_direction">
              <p class="mobile-hr-job-card__label">专业方向</p>
              <p class="mobile-hr-job-card__text" v-html="item.major_direction"></p>
            </div>

            <div class="mobile-hr-job-card__section" v-if="item.experience">
              <p class="mobile-hr-job-card__label">经验要求</p>
              <p class="mobile-hr-job-card__text" v-html="item.experience"></p>
            </div>

            <div class="mobile-hr-job-card__email">
              <span class="mobile-hr-job-card__email-label">简历投递：</span>
              <span class="mobile-hr-job-card__email-link">xhrs@sailhero.com.cn</span>
            </div>
          </div>

          <!-- 查看更多按钮 -->
          <div class="mobile-hr-loadmore" v-if="hasMore">
            <button 
              class="mobile-hr-loadmore__button"
              @click="showMore"
              :disabled="loadingMore"
            >
              <span v-if="loadingMore">加载中...</span>
              <span v-else>查看更多</span>
            </button>
          </div>
          
          <!-- 全部加载完毕提示 -->
          <div class="mobile-hr-loadmore" v-else>
            <p class="mobile-hr-loadmore__text">已加载全部职位</p>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="mobile-hr-empty" v-else>
          <div class="mobile-hr-empty__icon">💼</div>
          <p class="mobile-hr-empty__text">暂无招聘信息</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileHumanResources",
  data() {
    return {
      activeTab: 'policy',      // 当前激活的Tab（policy/jobs）
      jobList: [],              // 完整的招聘信息列表
      displayCount: 3,          // 当前显示的数量
      loading: false,           // 初始加载状态
      loadingMore: false        // 加载更多状态
    };
  },
  computed: {
    // 当前显示的职位列表
    displayList() {
      return this.jobList.slice(0, this.displayCount);
    },
    // 是否还有更多数据
    hasMore() {
      return this.displayCount < this.jobList.length;
    }
  },
  methods: {
    /**
     * 获取招聘信息列表
     */
    fetchJobList() {
      const _this = this;
      _this.loading = true;

      _this.$api.post(
        "/Client/getOpenPositions",
        {
          pageSize: 100,
          pageIndex: 1
        },
        function (res) {
          _this.loading = false;

          if (res.code === "200") {
            _this.jobList = res.data || [];
            // 重置显示数量为3
            _this.displayCount = 3;
          }
        },
        function (error) {
          _this.loading = false;
          console.error('获取招聘信息失败:', error);
        }
      );
    },

    /**
     * 查看更多（每次增加3条）
     */
    showMore() {
      if (this.hasMore) {
        this.loadingMore = true;
        
        // 模拟加载延迟
        setTimeout(() => {
          this.displayCount += 3;
          this.loadingMore = false;
        }, 300);
      }
    }
  },

  watch: {
    // 监听Tab切换，切换到招聘信息时加载数据
    activeTab(newTab) {
      if (newTab === 'jobs' && this.jobList.length === 0) {
        this.fetchJobList();
      }
    }
  },

  mounted() {
    // 如果默认显示招聘信息，则加载数据
    if (this.activeTab === 'jobs') {
      this.fetchJobList();
    }
  }
};
</script>

<style scoped>
@import '../../../assets/aboutSailHero/css/human-resources-mobile.css';
</style>

